<div class="page">
  <div class="top">
    <h1 class="title">Configuraciones</h1>
    <p>Administra las distintas opciones de personalización del sistema</p>
  </div>

  <mat-stepper class="consulta-stepper">
    <!-- !=========================================================
         !1. EDITAR INSTITUCIÓN DE SALUD
         !========================================================= -->
    @if (tieneRol('ADMIN')) {
      <mat-step [stepControl]="clinicaForm">
        <ng-template matStepLabel>
          <div class="step-label">
            <mat-icon class="material-symbols-outlined"> family_home </mat-icon>
            Editar institución
          </div>
        </ng-template>

        <div class="section-card expediente-card">
          <div class="section-header">
            <mat-icon class="material-symbols-outlined"> family_home </mat-icon>

            <div>
              <h2>Información de la institución de salud</h2>
              <p>Actualiza los datos de la institución de salud</p>
            </div>

            <button
              mat-flat-button
              type="button"
              class="add-boton add-boton--derecha"
              (click)="abrirDialogRedSocial()"
            >
              <mat-icon class="material-symbols-outlined">alternate_email</mat-icon>
              Agregar redes sociales
            </button>
          </div>

          <form [formGroup]="clinicaForm" class="form" (ngSubmit)="guardarClinica()">
            <!-- LOGO -->
            <div class="logo-section">
              <div class="logo-preview">
                @if (vistaPreviaLogo) {
                  <img [src]="vistaPreviaLogo" alt="Vista previa del logo" />
                } @else if (logoClinica) {
                  <img [src]="logoClinica" alt="Logo de la institución" />
                } @else {
                  <mat-icon class="material-symbols-outlined"> image </mat-icon>
                }
              </div>

              <div class="logo-info">
                <h3>Logo de la institución</h3>

                <p>Selecciona el logo que utilizará la institución.</p>

                <input
                  #inputLogo
                  type="file"
                  accept="image/png,image/jpeg,image/webp"
                  hidden
                  (change)="seleccionarLogo($event)"
                />

                <div class="logo-actions">
                  <button mat-stroked-button type="button" (click)="inputLogo.click()">
                    <mat-icon>upload</mat-icon>
                    Seleccionar logo
                  </button>

                  @if (archivoLogoSeleccionado) {
                    <button
                      mat-flat-button
                      class="add-boton"
                      type="button"
                      [disabled]="subiendoLogo"
                      (click)="subirLogo()"
                    >
                      @if (subiendoLogo) {
                        <mat-spinner diameter="20"></mat-spinner>
                        <span>Subiendo...</span>
                      } @else {
                        <mat-icon>cloud_upload</mat-icon>
                        Actualizar logo
                      }
                    </button>
                  }
                </div>

                @if (archivoLogoSeleccionado) {
                  <small>
                    Archivo seleccionado:
                    {{ archivoLogoSeleccionado.name }}
                  </small>
                }

                <small> Formatos permitidos: PNG, JPG o WEBP. Máximo 5 MB. </small>
              </div>
            </div>

            <!-- DATOS DE LA INSTITUCIÓN -->
            <div class="form-grid">
              <mat-form-field appearance="outline">
                <mat-label>Nombre de la institución</mat-label>

                <input matInput formControlName="nombre" placeholder="Nombre de la institución" />

                @if (clinicaForm.get('nombre')?.hasError('required')) {
                  <mat-error> El nombre es obligatorio. </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Dirección de la institución</mat-label>

                <input
                  matInput
                  formControlName="direccion"
                  placeholder="Dirección de la institución"
                />

                @if (clinicaForm.get('direccion')?.hasError('required')) {
                  <mat-error> La dirección es obligatoria. </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Clave de la institución</mat-label>

                <input
                  matInput
                  type="text"
                  inputmode="numeric"
                  formControlName="claveClinica"
                  placeholder="Clave de la institución"
                />

                @if (clinicaForm.get('claveClinica')?.hasError('required')) {
                  <mat-error>La clave es obligatoria.</mat-error>
                }

                @if (clinicaForm.get('claveClinica')?.hasError('pattern')) {
                  <mat-error> La clave debe ser un número entero positivo. </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- REDES SOCIALES -->
            <div class="lista-medicamentos full">
              <h2>Redes sociales</h2>

              @if (redSocialAgregada.length === 0) {
                <p class="sin-datos">No se han agregado redes sociales.</p>
              }

              @for (red of redSocialAgregada; track red.id) {
                <div class="medicamento-item">
                  <div class="med-info">
                    <div class="med-header">
                      <mat-icon class="material-symbols-outlined">alternate_email</mat-icon>
                      <strong>{{ red.redSocial }}</strong>
                    </div>

                    <div class="med-detalles">
                      <span>
                        <b>Usuario:</b>
                        {{ red.usuario }}
                      </span>
                    </div>
                  </div>

                  <div class="med-actions">
                    <button
                      mat-icon-button
                      class="edit-btn"
                      type="button"
                      (click)="editarRedSocial($index)"
                      matTooltip="Editar red social"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>

                    <button
                      mat-icon-button
                      class="delete-btn"
                      type="button"
                      (click)="eliminarRedSocial($index)"
                      matTooltip="Eliminar red social"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>

            <!-- INFORMACIÓN NO EDITABLE -->
            <div class="readonly-section">
              <div class="readonly-item">
                <mat-icon class="material-symbols-outlined"> badge </mat-icon>

                <div>
                  <span>Plan</span>

                  <strong>
                    {{ suscripcionActual?.plan?.nombre || 'Sin plan' }}
                  </strong>
                </div>
              </div>
            </div>

            <!-- ACCIONES -->
            <div class="actions">
              <button
                mat-flat-button
                type="submit"
                class="add-boton"
                [disabled]="clinicaForm.invalid"
              >
                Guardar cambios <mat-icon>save</mat-icon>
              </button>
            </div>
          </form>
        </div>
      </mat-step>
    }

    <!-- !=========================================================
         !2. ALTA DE PERSONAL
         !========================================================= -->
    @if (tieneRol('ADMIN')) {
      <mat-step [stepControl]="altaFormGroup">
        <form [formGroup]="altaFormGroup">
          <ng-template matStepLabel>
            <div class="step-label">
              <mat-icon class="material-symbols-outlined"> person_heart </mat-icon>

              Alta de personal
            </div>
          </ng-template>

          <div class="section-card">
            <div class="section-header">
              <mat-icon class="material-symbols-outlined">person_heart</mat-icon>

              <div>
                <h2>Alta de médicos y enfermeros</h2>
                <p>Registra la información del médico o enfermero.</p>
              </div>

              <button
                mat-flat-button
                type="button"
                class="add-boton add-boton--derecha"
                (click)="abrirDialogPersonal()"
              >
                <mat-icon class="material-symbols-outlined">person_add</mat-icon>
                Agregar médico o enfermero
              </button>
            </div>

            <div class="lista-medicamentos full">
              <h2>Personal agregado</h2>

              @if (personalAgregado.length === 0) {
                <p class="sin-datos">No se ha agregado personal.</p>
              }

              @for (personal of personalAgregado; track $index) {
                <div class="medicamento-item">
                  <div class="med-info">
                    <div class="med-header">
                      <mat-icon class="material-symbols-outlined"> person_check </mat-icon>

                      <strong>
                        {{ $index + 1 }}.
                        {{ personal.nombre }}
                        {{ personal.apellidoPaterno }}
                        {{ personal.apellidoMaterno }}
                      </strong>
                    </div>

                    <div class="med-detalles">
                      <span>
                        <b>Rol:</b>
                        {{ personal.rol.nombre }}
                      </span>

                      <span>
                        <b>Cédulas:</b>

                        @for (c of personal.cedulas; track $index) {
                          {{ c.tipoCedula }}: {{ c.cedula }}

                          @if (!$last) {
                            ,
                          }
                        }
                      </span>

                      <span>
                        <b>Email:</b>
                        {{ personal.email }}
                      </span>
                    </div>
                  </div>

                  <div class="med-actions">
                    <button
                      mat-icon-button
                      class="edit-btn"
                      type="button"
                      (click)="editarPersonal($index)"
                      matTooltip="Editar"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>

                    <button
                      mat-icon-button
                      class="delete-btn"
                      type="button"
                      (click)="eliminarPersonal($index)"
                      matTooltip="Eliminar"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </form>
      </mat-step>
    }

    <!-- !=========================================================
         !3. PLANES
         !========================================================= -->
    @if (tieneRol('ADMIN')) {
      <mat-step [stepControl]="configuracionForm">
        <form [formGroup]="configuracionForm">
          <ng-template matStepLabel>
            <div class="step-label">
              <mat-icon class="material-symbols-outlined"> upgrade </mat-icon>

              Planes
            </div>
          </ng-template>

          <div class="section-card">
            <div class="section-header">
              <mat-icon class="material-symbols-outlined"> upgrade </mat-icon>

              <div>
                <h2>Planes</h2>

                <p>Consulta y administra el plan de la institución.</p>
              </div>
            </div>

            <!-- PLAN ACTUAL -->
            <div class="datos">
              <div class="dato-item">
                <div class="icon-box">
                  <mat-icon>workspace_premium</mat-icon>
                </div>

                <div class="info">
                  <h1>
                    {{ suscripcionActual?.plan?.nombre || 'Sin plan' }}
                  </h1>

                  <p>
                    Plan actual:
                    {{ suscripcionActual?.plan?.nombre || 'Sin plan' }}
                  </p>

                  <p>
                    Número máximo de usuarios:
                    {{ suscripcionActual?.plan?.usuariosMaximos }}
                  </p>

                  <p>
                    Número máximo de pacientes:
                    {{ suscripcionActual?.plan?.pacientesMaximos }}
                  </p>

                  <p>
                    Fecha de inicio:
                    {{ suscripcionActual?.fechaInicio | date: 'dd/MM/yyyy' }}
                  </p>

                  <p>
                    Fecha de término:
                    {{ suscripcionActual?.fechaTermino | date: 'dd/MM/yyyy' }}
                  </p>
                </div>
              </div>
            </div>

            <!-- PLAN BASE -->
            <div class="datos">
              <div class="dato-item">
                <div class="icon-box">
                  <mat-icon class="material-symbols-outlined"> stat_1 </mat-icon>
                </div>

                <div class="info">
                  <h1>Base</h1>

                  <p>Número máximo de usuarios: 5</p>
                  <p>Número máximo de pacientes: 15</p>
                  <p>Duración del plan: 6 meses</p>
                </div>
              </div>

              <div class="dato-item">
                <div class="info">
                  <button mat-flat-button class="add-boton" type="button">
                    Cambiar plan <mat-icon class="material-symbols-outlined"> stat_1 </mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- PLAN PROFESIONAL -->
            <div class="datos">
              <div class="dato-item">
                <div class="icon-box">
                  <mat-icon class="material-symbols-outlined"> stat_2 </mat-icon>
                </div>

                <div class="info">
                  <h1>Profesional</h1>

                  <p>Número máximo de usuarios: 10</p>
                  <p>Número máximo de pacientes: 25</p>
                  <p>Duración del plan: 12 meses</p>
                </div>
              </div>

              <div class="dato-item">
                <div class="info">
                  <button mat-flat-button class="add-boton" type="button">
                    Cambiar plan <mat-icon class="material-symbols-outlined"> stat_2 </mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- PLAN PREMIUM -->
            <div class="datos">
              <div class="dato-item">
                <div class="icon-box">
                  <mat-icon class="material-symbols-outlined"> stat_3 </mat-icon>
                </div>

                <div class="info">
                  <h1>Premium</h1>

                  <p>Número máximo de usuarios: 20</p>
                  <p>Número máximo de pacientes: 50</p>
                  <p>Duración del plan: 12 meses</p>
                </div>
              </div>

              <div class="dato-item">
                <div class="info">
                  <button mat-flat-button class="add-boton" type="button">
                    Cambiar plan <mat-icon class="material-symbols-outlined"> stat_3 </mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </mat-step>
    }

    <!-- !=========================================================
         !4. FORMATO DE EXPEDIENTE
         !========================================================= -->
    @if (tieneRol('ADMIN')) {
      <mat-step [stepControl]="expedienteForm">
        <ng-template matStepLabel>
          <div class="step-label">
            <mat-icon class="material-symbols-outlined"> bookmark_manager </mat-icon>

            Formato de expediente
          </div>
        </ng-template>

        <div class="section-card expediente-card">
          <div class="section-header">
            <mat-icon class="material-symbols-outlined"> bookmark_manager </mat-icon>

            <div>
              <h2>Configurar formato de expediente</h2>

              <p>
                Personaliza la forma en que se generarán los números de expediente de los pacientes.
              </p>
            </div>
          </div>

          <form
            [formGroup]="expedienteForm"
            class="form"
            (ngSubmit)="guardarConfiguracionExpediente()"
          >
            <div class="form-grid">
              <mat-form-field appearance="outline">
                <mat-label>Prefijo</mat-label>

                <input matInput formControlName="prefijo" maxlength="10" placeholder="PAC" />

                <mat-hint> Ejemplo: PAC </mat-hint>

                @if (expedienteForm.get('prefijo')?.hasError('required')) {
                  <mat-error> El prefijo es obligatorio. </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Longitud del consecutivo</mat-label>

                <input matInput type="number" formControlName="longitud" min="1" max="20" />

                <mat-hint> Cantidad de dígitos del consecutivo. </mat-hint>

                @if (expedienteForm.get('longitud')?.hasError('required')) {
                  <mat-error> La longitud es obligatoria. </mat-error>
                }

                @if (
                  expedienteForm.get('longitud')?.hasError('min') ||
                  expedienteForm.get('longitud')?.hasError('max')
                ) {
                  <mat-error> La longitud debe estar entre 1 y 20. </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" class="formato-field">
                <mat-label> Formato del expediente </mat-label>

                <input
                  matInput
                  formControlName="formato"
                  placeholder="{PREFIJO}-{YY}-{MM}-{CONSECUTIVO}"
                />

                @if (expedienteForm.get('formato')?.hasError('required')) {
                  <mat-error> El formato es obligatorio. </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- VISTA PREVIA -->
            <div class="preview-expediente">
              <div class="preview-icon">
                <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
              </div>

              <div class="preview-info">
                <span>Vista previa</span>

                <strong>
                  {{ vistaPreviaExpediente() }}
                </strong>
              </div>
            </div>

            <!-- ACCIONES -->
            <div class="actions">
              <button
                mat-flat-button
                type="submit"
                class="add-boton"
                [disabled]="expedienteForm.invalid || guardandoExpediente"
              >
                @if (guardandoExpediente) {
                  <mat-spinner diameter="20"></mat-spinner>
                  <span>Guardando...</span>
                } @else {
                  <span>Guardar configuración</span>
                }
                <mat-icon>save</mat-icon>
              </button>
            </div>
          </form>
        </div>
      </mat-step>
    }

    <!-- !=========================================================
      !   5. PERSONALIZAR RECETA
         !========================================================= -->
    @if (tieneRol('ADMIN')) {
      <mat-step [stepControl]="recetaFormGrup">
        <form [formGroup]="recetaFormGrup">
          <ng-template matStepLabel>
            <div class="step-label">
              <mat-icon class="material-symbols-outlined"> dashboard_2_edit </mat-icon>

              Personalizar receta
            </div>
          </ng-template>

          <div class="section-card">
            <div class="section-header">
              <mat-icon class="material-symbols-outlined"> dashboard_2_edit </mat-icon>

              <div>
                <h2>Personalizar receta</h2>

                <p>Configura la disposición, colores y marca de agua de tus recetas.</p>
              </div>
            </div>

            <app-configuracion-recetas></app-configuracion-recetas>
          </div>
        </form>
      </mat-step>
    }

    <!-- ! =========================================================
        ! 6. AGREGAR INDICACIONES
        ! ========================================================= -->
    @if (tieneRol('ADMIN') || tieneRol('MEDIC@')) {
      <mat-step [stepControl]="indicacionesFormGrup">
        <form [formGroup]="indicacionesFormGrup">
          <ng-template matStepLabel>
            <div class="step-label">
              <mat-icon class="material-symbols-outlined"> format_list_bulleted_add </mat-icon>

              Agregar indicaciones
            </div>
          </ng-template>

          <div class="section-card">
            <div class="section-header">
              <mat-icon class="material-symbols-outlined"> format_list_bulleted_add </mat-icon>

              <div>
                <h2>Agregar indicaciones generales</h2>

                <p>Las indicaciones agregadas se mostrarán en las consultas.</p>
              </div>
              <button
                mat-flat-button
                type="button"
                class="add-boton add-boton--derecha"
                (click)="abrirDialogIndicaciones()"
              >
                <mat-icon>add</mat-icon>

                Agregar indicación
              </button>
            </div>

            <div class="lista-medicamentos full">
              <h2>Indicaciones agregadas</h2>

              @if (indicacionesAgregadas.length === 0) {
                <p class="sin-datos">No se han agregado indicaciones.</p>
              }

              @for (indicacion of indicacionesAgregadas; track $index) {
                <div class="medicamento-item">
                  <div class="med-info">
                    <div class="med-header">
                      <mat-icon class="material-symbols-outlined"> format_list_bulleted </mat-icon>

                      <strong>
                        {{ $index + 1 }}.
                        {{ indicacion.titulo }}
                      </strong>
                    </div>

                    <div class="med-detalles">
                      <span>
                        <b>Descripción:</b>
                        {{ indicacion.descripcion }}
                      </span>
                    </div>
                  </div>

                  <div class="med-actions">
                    <button
                      mat-icon-button
                      class="edit-btn"
                      type="button"
                      (click)="editarIndicaciones($index)"
                      matTooltip="Editar indicación"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>

                    <button
                      mat-icon-button
                      class="delete-btn"
                      type="button"
                      (click)="eliminarIndicaciones($index)"
                      matTooltip="Eliminar indicación"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </form>
      </mat-step>
    }

    <!-- ! =========================================================
       !  6. AGREGAR MUNICIPIOS Y BARRIOS
        ! ========================================================= -->

    @if (tieneRol('ADMIN')) {
      <mat-step [stepControl]="municipiosFormGrup">
        <form [formGroup]="municipiosFormGrup">
          <ng-template matStepLabel>
            <div class="step-label">
              <mat-icon class="material-symbols-outlined"> add_location_alt </mat-icon>

              Agregar catálogo de municipio y barrios
            </div>
          </ng-template>

          <div class="section-card">
            <div class="section-header">
              <mat-icon class="material-symbols-outlined"> format_list_bulleted_add </mat-icon>

              <div>
                <h2>Agregar municipio y barrios</h2>

                <p>Los catálogos agregados se mostrarán en las opciones de nuevo paciente.</p>
              </div>
              <button
                mat-flat-button
                type="button"
                class="add-boton add-boton--derecha"
                (click)="abrirDialogMunicipio()"
              >
                <mat-icon>add</mat-icon>

                Agregar municipio
              </button>
            </div>

            <div class="lista-medicamentos full">
              <h2>Municipios agregados</h2>

              @if (municipiosAgregadas.length === 0) {
                <p class="sin-datos">No se han agregado municipios.</p>
              }

              @for (municipio of municipiosAgregadas; track municipio.id) {
                <div class="medicamento-item">
                  <div class="med-info">
                    <div class="med-header">
                      <mat-icon class="material-symbols-outlined"> format_list_bulleted </mat-icon>

                      <strong> {{ $index + 1 }}. {{ municipio.nombre }} </strong>
                    </div>

                    <div class="med-detalles">
                      <span>
                        <b>Acrónimo:</b>
                        {{ municipio.acronimo }}
                      </span>
                    </div>
                  </div>

                  <div class="med-actions">
                    <button
                      mat-icon-button
                      class="edit-btn"
                      type="button"
                      (click)="abrirBarrios(municipio)"
                      matTooltip="Administrar barrios"
                    >
                      <mat-icon>location_city</mat-icon>
                    </button>

                    <button
                      mat-icon-button
                      class="edit-btn"
                      type="button"
                      (click)="editarMunicipio($index)"
                      matTooltip="Editar municipio"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>

                    <button
                      mat-icon-button
                      class="delete-btn"
                      type="button"
                      (click)="eliminarMunicipio($index)"
                      matTooltip="Eliminar municipio"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </form>
      </mat-step>
    }

    <!-- =========================================================
         7. EDITAR MI PERFIL
         ========================================================= -->
    <mat-step [stepControl]="perfilForm">
      <ng-template matStepLabel>
        <div class="step-label">
          <mat-icon class="material-symbols-outlined"> person_edit </mat-icon>

          Editar mi perfil
        </div>
      </ng-template>

      <div class="profile-container">
        <!-- INFORMACIÓN PERSONAL -->
        <section class="section-card">
          <div class="section-header">
            <mat-icon class="material-symbols-outlined"> person_edit </mat-icon>

            <div>
              <h2>Información personal</h2>

              <p>Actualiza tus datos personales.</p>
            </div>
          </div>

          <form [formGroup]="perfilForm" class="form" (ngSubmit)="guardarPerfil()">
            <div class="form-grid">
              <div formArrayName="cedulas" class="cedulas-container">
                <h3>Cédulas profesionales</h3>

                @for (grupo of cedulasPerfil.controls; track grupo; let i = $index) {
                  <div [formGroupName]="i" class="cedula-item">
                    <mat-form-field appearance="outline">
                      <mat-label>Tipo de cédula</mat-label>
                      <mat-select formControlName="tipoCedula">
                        @for (tipo of tiposCedula; track tipo.valor) {
                          <mat-option [value]="tipo.valor">{{ tipo.nombre }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Número de cédula</mat-label>
                      <input
                        matInput
                        type="text"
                        inputmode="numeric"
                        autocomplete="off"
                        maxlength="8"
                        placeholder="12345678"
                        formControlName="cedula"
                      />
                      @if (grupo.get('cedula')?.hasError('required')) {
                        <mat-error>La cédula es obligatoria.</mat-error>
                      }
                      @if (grupo.get('cedula')?.hasError('pattern')) {
                        <mat-error>La cédula debe tener entre 7 y 8 dígitos numéricos.</mat-error>
                      }
                    </mat-form-field>

                    <button mat-button type="button" color="warn" (click)="quitarCedulaPerfil(i)">
                      <mat-icon>delete</mat-icon>
                      Quitar cédula
                    </button>
                  </div>
                } @empty {
                  <p class="sin-datos">Sin cédulas registradas.</p>
                }
              </div>

              @if (cedulasPerfil.hasError('cedulaDuplicada')) {
                <p class="error-texto">No puedes repetir el mismo número de cédula.</p>
              }

              <!-- <button mat-stroked-button type="button" (click)="agregarCedulaPerfil()">
                <mat-icon>add</mat-icon>
                Agregar otra cédula
              </button> -->

              <mat-form-field appearance="outline">
                <mat-label>Nombre</mat-label>

                <input matInput formControlName="nombre" placeholder="Nombre" />

                @if (perfilForm.get('nombre')?.hasError('required')) {
                  <mat-error> El nombre es obligatorio. </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Apellido paterno</mat-label>

                <input matInput formControlName="apellidoPaterno" placeholder="Apellido paterno" />

                @if (perfilForm.get('apellidoPaterno')?.hasError('required')) {
                  <mat-error> El apellido paterno es obligatorio. </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Apellido materno</mat-label>

                <input matInput formControlName="apellidoMaterno" placeholder="Apellido materno" />

                @if (perfilForm.get('apellidoMaterno')?.hasError('required')) {
                  <mat-error> El apellido materno es obligatorio. </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- DATOS NO EDITABLES -->
            <div class="readonly-section">
              <div class="readonly-item">
                <mat-icon class="material-symbols-outlined"> badge </mat-icon>

                <div>
                  <span>Rol</span>

                  <strong>
                    {{ user?.rol?.nombre || 'Sin rol' }}
                  </strong>
                </div>
              </div>

              <div class="readonly-item">
                <mat-icon class="material-symbols-outlined"> mail </mat-icon>

                <div>
                  <span>Correo electrónico</span>

                  <strong>
                    {{ user?.email || 'Sin correo' }}
                  </strong>
                </div>
              </div>

              <div class="readonly-item">
                <mat-icon class="material-symbols-outlined"> clinical_notes </mat-icon>

                <div>
                  <span> Cédulas profesionales </span>

                  <strong>
                    @if (user?.cedulas?.length) {
                      @for (cedula of user.cedulas; track $index) {
                        {{ cedula.tipoCedula }}:
                        {{ cedula.cedula }}

                        @if (!$last) {
                          ,
                        }
                      }
                    } @else {
                      Sin cédulas registradas
                    }
                  </strong>
                </div>
              </div>
            </div>

            <div class="actions">
              <button
                mat-flat-button
                type="submit"
                class="add-boton"
                [disabled]="perfilForm.invalid"
              >
                Guardar cambios <mat-icon>save</mat-icon>
              </button>
            </div>
          </form>
        </section>

        <!-- CAMBIAR CONTRASEÑA -->
        <section class="section-card password-section">
          <div class="section-header">
            <mat-icon class="material-symbols-outlined"> lock </mat-icon>

            <div>
              <h2>Cambiar contraseña</h2>

              <p>Actualiza la contraseña de tu cuenta.</p>
            </div>
          </div>

          <form [formGroup]="passwordForm" class="form" (ngSubmit)="cambiarPassword()">
            <mat-form-field appearance="outline">
              <mat-label>Contraseña actual</mat-label>

              <input
                matInput
                [type]="mostrarPasswordActual ? 'text' : 'password'"
                formControlName="password"
                placeholder="Contraseña actual"
              />

              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="mostrarPasswordActual = !mostrarPasswordActual"
              >
                <mat-icon>
                  {{ mostrarPasswordActual ? 'visibility_off' : 'visibility' }}
                </mat-icon>
              </button>

              @if (passwordForm.get('password')?.hasError('required')) {
                <mat-error> La contraseña actual es obligatoria. </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Nueva contraseña</mat-label>

              <input
                matInput
                [type]="mostrarPasswordNueva ? 'text' : 'password'"
                formControlName="passwordNew"
                placeholder="Nueva contraseña"
              />

              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="mostrarPasswordNueva = !mostrarPasswordNueva"
              >
                <mat-icon>
                  {{ mostrarPasswordNueva ? 'visibility_off' : 'visibility' }}
                </mat-icon>
              </button>

              @if (passwordForm.get('passwordNew')?.hasError('required')) {
                <mat-error> La nueva contraseña es obligatoria. </mat-error>
              }

              @if (passwordForm.get('passwordNew')?.hasError('minlength')) {
                <mat-error> La contraseña debe tener al menos 8 caracteres. </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Confirmar nueva contraseña</mat-label>

              <input
                matInput
                [type]="mostrarPasswordConfirmar ? 'text' : 'password'"
                formControlName="passwordConfirm"
                placeholder="Confirmar nueva contraseña"
              />

              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="mostrarPasswordConfirmar = !mostrarPasswordConfirmar"
              >
                <mat-icon>
                  {{ mostrarPasswordConfirmar ? 'visibility_off' : 'visibility' }}
                </mat-icon>
              </button>

              @if (passwordForm.get('passwordConfirm')?.hasError('required')) {
                <mat-error> Confirma la nueva contraseña. </mat-error>
              }

              @if (passwordForm.get('passwordConfirm')?.hasError('minlength')) {
                <mat-error> La contraseña debe tener al menos 8 caracteres. </mat-error>
              }

              @if (passwordForm.get('passwordConfirm')?.hasError('passwordMismatch')) {
                <mat-error> Las contraseñas no coinciden. </mat-error>
              }
            </mat-form-field>

            <div class="actions">
              <button
                mat-flat-button
                type="submit"
                class="add-boton"
                [disabled]="passwordForm.invalid"
              >
                Guardar contraseña
                <mat-icon>lock_reset</mat-icon>
              </button>
            </div>
          </form>
        </section>
      </div>
    </mat-step>
  </mat-stepper>
</div>
